/*
 * @Author: shiguang
 * @Date: 2024-05-17 16:28:04
 * @LastEditors: shiguang
 * @LastEditTime: 2024-05-22 08:55:40
 * @Description:
 */
import { atom } from "jotai";
import { useParams, usePathname } from "next/navigation";
import { useTranslation } from "react-i18next";

/** 青蛙文章 当前状态是否是阅读记录 */
export const atomIsArticalReadRecord = atom(false);

export const requestReadRecordContext = (() => {
  let _requestReadRecordContext = () => {};
  return {
    setRequestReadRecordContext: (ctxFunction: () => void) => {
      _requestReadRecordContext = ctxFunction;
    },
    requestReadRecord: () => {
      _requestReadRecordContext();
    },
  };
})();

interface ReadRecordMenuItem {
  closeMenu: () => void;
}

export const ReadRecordMenuItem = (props: ReadRecordMenuItem) => {
  return null;
};
